import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import emailjs from 'emailjs-com';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-customer-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: "customer-form.component.html",
  styles: []
})
export class CustomerFormComponent {
  /** Initial data to populate the form with */
  @Input() initialData?: {
    /** Customer's business name */
    name?: string;
    /** Customer's email address */
    email?: string;
    /** Customer's password */
    password?: string;
  };

  /** Event emitter that fires when the form value changes */
  @Output() formChange = new EventEmitter<FormGroup>();

  /** The form group that manages customer details inputs */
  form: FormGroup;

  /** Flag to control password visibility */
  showPassword = false;

  constructor(private fb: FormBuilder,private http: HttpClient) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    // Emit form changes to parent component
    this.form.valueChanges.subscribe(() => {
      this.formChange.emit(this.form);
    });


  }

  /**
   * Lifecycle hook that initializes the component
   * Populates the form with initial data if provided
   */
  ngOnInit() {
    if (this.initialData) {
      this.form.patchValue(this.initialData);
    }
  }

  /**
   * Toggles the visibility of the password field
   * Switches between text and password input types
   */
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  /**
   * Generates a random password and sets it in the form
   * Creates a secure password with mixed characters
   */
  generatePassword() {
    const length = 12;
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+';
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    this.form.patchValue({ password });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      console.warn('Form non valido');
      return;
    }

    const { name, name2, email, password } = this.form.value;

    this.http.post(`${environment.apiUrl}/users`, {
      name,
      name2,
      email,
      password
    }).subscribe({
      next: () => {
        alert('Utente salvato con successo!');
        this.sendWelcomeEmail(email, password);
        this.form.reset();
      },
      error: (err) => {
        console.error('Errore nel salvataggio:', err);
        alert('Errore nel salvataggio');
      }
    });
  }

  sendWelcomeEmail(email: string, password: string) {
    const templateParams = {
      to_email: email,
      password: password,
      message: `Ciao!\n\nBenvenuto su FeedMe Sales Panel.\n\nLa tua password è: ${password}\n\nAccedi subito e cambia la tua password al primo login!`
    };

    console.warn('Invio mail a:'+email);

    emailjs.send(
      'service_zncbhbm',     // es: service_abc123
      'template_l6qyxyb',    // es: template_xyz456
      templateParams,
      'D1UW5bOCHzisKM23l'      // es: user_789def
    ).then(
      (response) => {
        console.log('Email inviata con successo', response.status, response.text);
      },
      (error) => {
        console.error('Errore invio email:', error);
      }
    );
  }

}
